
<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>Import Deliveries Data</h1>
<div mat-dialog-content>
    <table>
        <thead>
            <tr>
                <th>DELIVERY DATE</th>
                <th>NAME</th>
                <th>SURNAME</th>
                <th>STATUS</th>
                <th>ADDRESS</th>
                <th>INTERCOM</th>
                <th>PRODUCTS</th>
                <th>PARTNER</th>
                <th>EXPERT</th>
                <th>FROM TIME</th>
                <th>TO TIME</th>
                <th>NOTES</th>
                <th>REQUEST EXPERT</th>
            </tr>
        </thead>
        <tbody>
        <tr *ngFor="let delivery of deliveries">
            <td>{{ delivery?.deliveryDate }}</td>
            <td>{{ delivery?.name }}</td>
            <td>{{ delivery?.surname }}</td>
            <td>{{ delivery?.status }}</td>
            <td>{{ delivery?.address }}</td>
            <td>{{ delivery?.intercom }}</td>
            <td *ngFor="let product of delivery?.deliveryProducts">
                <span>{{ product }}</span>
            </td>
            <td>{{ delivery?.partner?.id }}</td>
            <td>{{ delivery?.expert?.id }}</td>
            <td>{{ delivery?.fromTime }}</td>
            <td>{{ delivery?.toTime }}</td>
            <td>{{ delivery?.notes }}</td>
            <td>{{ delivery?.requestExpert }}</td>
        </tr>
        </tbody>
    </table>
</div>
<div mat-dialog-actions>
  <div>
    <button mat-button class="btn" (click)=handleImport()>
      IMPORT<i class="ml-10 far fa-save"></i>
    </button>

  </div>
</div>